import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

export const OverlayMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 500;
  color: ${COLORS.PRIMARY};
  gap: 0.5rem;

  svg {
    font-size: 2rem;
  }
`;
